import { cn } from '../../lib/cn';

export type ButtonVariant =
  'primary' | 'secondary' | 'ghost' | 'onDark' | 'danger' | 'dangerOutline';
export type ButtonSize = 'sm' | 'md';

const BUTTON_BASE =
  'inline-flex items-center justify-center gap-1.5 rounded-lg font-medium whitespace-nowrap transition-colors disabled:cursor-not-allowed disabled:opacity-55';
const BUTTON_VARIANT: Record<ButtonVariant, string> = {
  primary:
    'bg-brand-700 text-white shadow-xs hover:bg-brand-800 dark:bg-brand-500 dark:text-slate-950 dark:hover:bg-brand-400',
  secondary:
    'border border-slate-300 bg-white text-slate-800 shadow-xs hover:bg-slate-50 dark:border-slate-700 dark:bg-slate-900 dark:text-slate-100 dark:hover:bg-slate-800',
  ghost: 'text-slate-700 hover:bg-slate-100 dark:text-slate-300 dark:hover:bg-slate-800',
  /** On a surface that stays dark in both themes, such as a command box. */
  onDark: 'border border-slate-500 text-slate-100 hover:bg-slate-800',
  danger: 'bg-red-700 text-white shadow-xs hover:bg-red-800 dark:bg-red-600 dark:hover:bg-red-500',
  dangerOutline:
    'border border-red-600 bg-white text-red-700 shadow-xs hover:bg-red-50 dark:border-red-500 dark:bg-slate-900 dark:text-red-300 dark:hover:bg-red-950/50',
};
const BUTTON_SIZE: Record<ButtonSize, string> = {
  sm: 'h-8 px-2.5 text-xs',
  md: 'h-9 px-3.5 text-sm',
};

export function buttonClass(variant: ButtonVariant = 'primary', size: ButtonSize = 'md') {
  return cn(BUTTON_BASE, BUTTON_VARIANT[variant], BUTTON_SIZE[size]);
}
